import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import UserProfile from './UserProfile';

const Navigation = () => {
  const location = useLocation();
  const { user, signOut, hasPermission } = useAuth();
  const navigate = useNavigate();
  const [showProfile, setShowProfile] = useState(false);
  
  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="px-3" data-testid="main-nav">
        <Navbar.Brand as={Link} to="/" className="d-flex flex-column">
          <div>IRIS</div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {user && (
              <>
                
                  <Nav.Link as={Link} to="/" active={location.pathname === '/'}>
                    Dashboard
                  </Nav.Link>
                
                {hasPermission('invoices', 'analyze') && (
                  <Nav.Link as={Link} to="/capture" active={location.pathname === '/capture'}>
                    Invoice Capture
                  </Nav.Link>
                )}
                {hasPermission('extractions', 'view') && (
                  <Nav.Link as={Link} to="/extraction-jobs" active={location.pathname.startsWith('/extraction-jobs')}>
                    Extraction Jobs
                  </Nav.Link>
                )}

                {hasPermission('customers', 'view') && (
                  <Nav.Link as={Link} to="/customers" active={location.pathname === '/customers'}>
                    Customer Management
                  </Nav.Link>
                )}
                {hasPermission('reports', 'view') && (
                  <Nav.Link as={Link} to="/reports" active={location.pathname === '/reports'}>
                    Reports
                  </Nav.Link>
                )}
                {hasPermission('permissions', 'manage') && (
                  <NavDropdown title="Admin" id="admin-dropdown" 
                    active={location.pathname === '/users' || location.pathname === '/roles' || location.pathname === '/audit' || location.pathname === '/admin/model-configuration'}>
                    <NavDropdown.Item as={Link} to="/users" active={location.pathname === '/users'}>
                      Users
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/roles" active={location.pathname === '/roles'}>
                      Roles
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/audit" active={location.pathname === '/audit'}>
                      Audit History
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/admin/model-configuration" active={location.pathname === '/admin/model-configuration'}>
                      Model Configuration
                    </NavDropdown.Item>
                  </NavDropdown>
                )}
              </>
            )}
          </Nav>
          <Nav>
            {user ? (
              <>
                <NavDropdown 
                  title={`${user.attributes?.given_name || ''} ${user.attributes?.family_name || ''}`.trim() || user.attributes?.email}
                  id="user-dropdown"
                  align="end"
                  data-testid="user-dropdown"
                >
                  <NavDropdown.Item onClick={() => setShowProfile(true)}>
                    Manage Profile
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={handleSignOut} data-testid="nav-sign-out">
                    Sign Out
                  </NavDropdown.Item>
                </NavDropdown>
                <UserProfile 
                  show={showProfile} 
                  onHide={() => setShowProfile(false)} 
                />
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login" active={location.pathname === '/login'}>
                  Log In
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
    </Navbar>
  );
};

export default Navigation;